import accessibleAutocomplete from "accessible-autocomplete";

const jobsList = [].slice.call(document.querySelectorAll("input[data-role]"));

const jobs = jobsList.map((job) => {
	return job.getAttribute("name");
});

// Used to add GA events for no-result searches
var noResultsVal = "";
var timeout = void 0;

const locale = document.querySelector("#locale").value;

const opts = {
	autoselect: true,
	minLength: 2,
	onConfirm: (i) => {
		if (i) {
			let url = document.querySelector(`input[name="${i}"]`).value;
			return (selectedUrl = url);
		}
	},
	tNoResults: () => {
		// Get the current typed query
		val = document.getElementById("jobs-autocomplete").value;

		// If the previous no result search is the same, ignore (to de-dupe multiple events caused when hovering over results list)
		if (noResultsVal !== val) {
			// Is a timeout running? If it is clear it as the user is still typing
			if (timeout) {
				clearTimeout(timeout);
			}

			// Set a timeout which waits for half a second to check a user has stopped typing (not ideal)
			timeout = setTimeout(function () {
				// Log GA Event of the search term
				window.ga("send", "event", "Qualification Framework", "Search", val);
			}, 500);
		}

		// Update the no results search text to de-dupe
		noResultsVal = val;

		if (locale == "cy-GB") {
			return "Dim canlyniadau";
		} else {
			return "No results";
		}
	},
	tStatusQueryTooShort: (minQueryLength) => {
		if (locale == "cy-GB") {
			return `Teipiwch o leiaf ${minQueryLength} llythyr am canlyniadau.`;
		} else {
			return `Type in ${minQueryLength} or more characters for results.`;
		}
	},
	tStatusResults: (length, contentSelectedOption) => {
		if (locale == "cy-GB") {
			return `<span>${length} canlyniad ar gael. ${contentSelectedOption}</span>`;
		} else {
			const words = {
				result: length === 1 ? "result" : "results",
				is: length === 1 ? "is" : "are",
			};
			return `<span>${length} ${words.result} ${words.is} available. ${contentSelectedOption}</span>`;
		}
	},
	tStatusSelectedOption: (selectedOption, length, index) => {
		if (locale == "cy-GB") {
			return `${selectedOption} (${index + 1} o ${length}) wedi'i ddewis.`;
		} else {
			return `${selectedOption} (${index + 1} of ${length}) is selected.`;
		}
	},
	templates: {
		inputValue: (val) => {
			let alt = document.querySelector(`[data-altname][name="${val}"]`);
			if (alt) {
				let real = document.querySelector(
					`[data-real][value="${alt.getAttribute("value")}"]`,
				);
				return `${real.getAttribute("name")} - (${alt.getAttribute("name")})`;
			} else {
				return `${val ? val : ""}`;
			}
		},
		suggestion: (val) => {
			let alt = document.querySelector(`[data-altname][name="${val}"]`);
			if (alt) {
				let real = document.querySelector(
					`[data-real][value="${alt.getAttribute("value")}"]`,
				);
				return `<p class="suggested">${val} <span class="suggested__alt">${real.getAttribute(
					"name",
				)}</span></p>`;
			} else {
				return `${val}`;
			}
		},
	},
};

const jobOptions = Object.assign(
	{
		element: document.querySelector("#jobs-autocomplete-container"),
		id: "jobs-autocomplete", // To match it to the existing <label>.
		source: jobs,
	},
	opts,
);

let selectedUrl = null;

[].forEach.call(
	document.querySelectorAll('[name="type-selector"]'),
	(input) => {
		return input.addEventListener("change", clearSearch, false);
	},
);

[].forEach.call(document.querySelectorAll("[data-search-submit]"), (input) => {
	return input.addEventListener("click", redirect, false);
});

function redirect(e) {
	e.preventDefault();

	if (selectedUrl) {
		return (window.location = selectedUrl);
	}

	return;
}

function clearSearch() {
	[].forEach.call(
		document.querySelectorAll('[name="input-autocomplete"]'),
		(input) => {
			selectedUrl = null;
			input.value = "";
			return this;
		},
	);
}

accessibleAutocomplete(jobOptions);
